import { useQuery } from '@tanstack/react-query';
import { monitoringStatusApi } from '@/domains/landing-page/apis/monitoring-status';
import type { MonitoringStatusPatientData } from '@/domains/landing-page/types/monitoring-status.types';

const REFETCH_INTERVAL_MS = 15000;

export const useMonitoringStatus = (reportCode?: string) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['monitoringStatus', reportCode],
    queryFn: async () => {
      const res = await monitoringStatusApi.getMonitoringStatus(reportCode as string);
      return res?.data ?? null;
    },
    enabled: reportCode != null,
    refetchInterval: REFETCH_INTERVAL_MS,
  });

  const patients: MonitoringStatusPatientData[] = data?.patients ?? [];

  return { patients, isLoading, isError };
};
